import { redirect } from "react-router";
import { PAGES } from "src/configs/pages-urls";
import { convertFrameworkRoute } from "src/utils/routes";

export default [
	{
		path: "",
		loader: () => redirect(PAGES.appStore.sub.allCategories),
	},
	{
		path: `${PAGES.appStore.path}/${PAGES.appStore.sub.app}/${PAGES.new}`,
		lazy: () =>
			import("src/module--app-store/pages/new-app.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.appStore.path}/${PAGES.appStore.sub.app}/:id/${PAGES.edit}`,
		lazy: () =>
			import("src/module--app-store/pages/edit-app.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.appStore.sub.allCategories}`,
		lazy: () =>
			import("src/module--app-store/pages/all-categories.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.appStore.sub.apps}`,
		lazy: () =>
			import("src/module--app-store/pages/apps.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.appStore.sub.app}/:id`,
		lazy: () =>
			import("src/module--app-store/pages/app.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.appStore.sub.builder}`,
		lazy: () =>
			import("src/module--app-store/pages/new-app.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.appStore.sub.recipes}`,
		lazy: () =>
			import("src/module--app-store/pages/recipes.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.appStore.sub.recipe}/:id`,
		lazy: () =>
			import("src/module--app-store/pages/recipe.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.appStore.sub.installed}`,
		lazy: () =>
			import("src/module--app-store/pages/installed.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.appStore.sub.aiAgents}`,
		lazy: () =>
			import("src/module--app-store/pages/ai-agents.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.appStore.sub.partnerships}`,
		lazy: () =>
			import("src/module--app-store/pages/partnerships.page").then(
				convertFrameworkRoute,
			),
	},
];
